module.exports = __webpack_public_path__ + "img/project15_7.jpeg.f385d762.webp";